// Module
var code = `<div class="content-margin io-stats" data-bind="with: graph">
    <div data-bind="compose: \$root.graphView"></div>
</div>    

`;
// Exports
export default code;